export default __webpack_public_path__ + "static/7_33-9b11e33e369a0b4f9218fef505da9287.png";